import React, { useEffect } from 'react';
import {
  Accordion
} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import Item from '../../faqspage/section-fqs-item';
import { fetchFaqsServicios } from '../../../redux/actions/apiAction';
import classes from './sectionFaqs.module.css';

const SectionFaqs = ({ loading, faqs_service, error, fetchFaqsServicios }) => {
  useEffect(() => {
    fetchFaqsServicios();
  }, [fetchFaqsServicios]);
  return (
    <div className={classes.containerFaqs}>
      <div className={classes.headerContainer}>
        <h1 className="main-text slide-title">Dudas frecuentes</h1>
      </div>
      <div className={classes.contenerAccordion}>
        <Accordion defaultActiveKey={1}>
          {loading && 'Cargando datos ...'}
          {error && 'Error al cargar los datos'}
          {
            faqs_service && faqs_service.length ?
              faqs_service.map((item, index) => {
                return <Item data={item} key={index} />
              })
              : ''
          }
        </Accordion>
      </div>
      <div className={classes.bottom}>
        <NavLink to="/faq" className="btn-red a-btn-red-lignt">Ver más preguntas frecuentes</NavLink>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    faqs_service: state.apiState.faqs_servicios,
  }
}

export default connect(
  mapStateToProps,
  { fetchFaqsServicios }
)(SectionFaqs);